<template>
  <div class="dashboard-page-wrapper test-page">
    <div class="top-wrap" v-if="tab === 'one'">
      <div class="text-img">
        <h2> Well & Sampling Information </h2>
        <div v-if="receivedData">
          <div v-if="pdfLoader === true" class="test-pdf-div">
            <div class="img-content">
              <img :src="pdf_loader_image" alt="loader Image" />
            </div>
          </div>
          <div v-else-if="receivedData.testID !== ''" @click="goToPdf()" class="test-pdf-div">
            <div class="img-content">
              <img :src="pdf_icon" alt="pdf icon" />
            </div>
          </div>
        </div>
      </div>
      <div class="top-content"
        v-if="receivedData && receivedData.headers && receivedData.headers.length > 0">
        <v-img src="../../../assets/Images/Assets/top image.png" alt="test image" width="49px" height="49px"></v-img>
        <div class="fields-info">
          <div class="fields-info-wrap" :style="{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '16px'
          }">
            <div
              v-for="(item, index) in receivedData.headers.filter(
                h => !(h.key && h.key.endsWith('_UOM'))
              )"
              :key="index"
              class="field-item"
            >
              <p style="margin: 0; font-weight: 500;">{{ item.displayName }}</p>
              <p class="test-top-values" style="margin: 0;">
                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props" v-if="typeof item.value === 'number'" class="value-text">
                      {{ item.digits > 0 ? item.value.toFixed(item.digits) : item.value }}
                    </span>
                    <span v-bind="props" v-else class="value-text">
                      {{ item.value }}
                    </span>
                  </template>
                  <span>{{ item.value }}</span>
                </v-tooltip>
                <span
                  v-if="item.key && receivedData.headers.some(
                    h => h.key === item.key + '_UOM'
                  )"
                  class="uom"
                >
                  &nbsp;{{
                    receivedData.headers.find(
                      h => h.key === item.key + '_UOM'
                    ).value
                  }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div v-if="!receivedData.headers || receivedData.headers.length === 0">
          No data available.
        </div>
      </div>

      <div class="top-content" v-else>
        <test-loaders />
      </div>
    </div>
    <div class="top-wrap" v-if="tab === 'two'">
      <div class="text-img">
        <h2> Fluids Test Summary </h2>
        <div v-if="receivedDataProperties">
          <div v-if="pdfLoader === true" class="test-pdf-div">
            <div class="img-content">
              <img :src="pdf_loader_image" alt="loader Image" />
            </div>
          </div>
          <div v-else-if="receivedDataProperties.testID !== ''" @click="goToPdf()" class="test-pdf-div">
            <div class="img-content">
              <img :src="pdf_icon" alt="pdf icon" />
            </div>
          </div>
        </div>
      </div>
      <div class="top-content"
        v-if="receivedDataProperties && receivedDataProperties.headers && receivedDataProperties.headers.length > 0">
        <v-img src="../../../assets/Images/Assets/top image.png" alt="test image" width="49px" height="49px"></v-img>
        <div class="fields-info">
          <div class="fields-info-wrap" :style="{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '16px'
          }">
            <div
              v-for="(item, index) in receivedDataProperties.headers.filter(
                h => !(h.key && h.key.endsWith('_UOM'))
              )"
              :key="index"
              class="field-item"
            >
              <p style="margin: 0; font-weight: 500;">{{ item.displayName }}</p>
              <p class="test-top-values" style="margin: 0;">
                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props" v-if="typeof item.value === 'number'" class="value-text">
                      {{ item.digits > 0 ? item.value.toFixed(item.digits) : item.value }}
                    </span>
                    <span v-bind="props" v-else class="value-text">
                      {{ item.value }}
                    </span>
                  </template>
                  <span>{{ item.value }}</span>
                </v-tooltip>
                <span
                  v-if="item.key && receivedDataProperties.headers.some(
                    h => h.key === item.key + '_UOM'
                  )"
                  class="uom"
                >
                  &nbsp;{{
                    receivedDataProperties.headers.find(
                      h => h.key === item.key + '_UOM'
                    ).value
                  }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div
          v-if="!receivedDataProperties.headers || receivedDataProperties.headers.length === 0">
          No data available.
        </div>
      </div>

      <div class="top-content" v-else>
        <test-loaders />
      </div>
    </div>
    <div ref="scrollable" class="tabs-data" tabindex="0" @keydown="handleKeyDown">
      <div class="tabs-toggle">
        <v-tabs v-model="tab">
          <v-tab value="one">Well & Sampling Information</v-tab>
          <v-tab value="two">Fluids Test Summary</v-tab>
        </v-tabs>

        <div class="scale-mass-mole">
          <v-avatar v-if="tab === 'one'" size="30" @click="downloadWellInfoCSV">
            <v-img :src="documentDownload"></v-img>
          </v-avatar>

          <v-avatar v-if="tab === 'two'" size="30" @click="downloadFluidsTestCSV">
            <v-img :src="documentDownload"></v-img>
          </v-avatar>
        </div>
      </div>

      <v-card-text class="pa-0">
        <v-window v-model="tab">
          <v-window-item value="one">
            <WellInfoTab ref="wellInfoTab" @data-updated="handleDataUpdate" />
          </v-window-item>

          <v-window-item value="two">
            <FluidsTestTab ref="fluidsTestTab" @data-updated="handleDataUpdateProperties" />
          </v-window-item>
        </v-window>
      </v-card-text>
    </div>
    <v-snackbar v-model="snackbarMessage" color="#E53535" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import WellInfoTab from "./Tables/WellInfoTab.vue";
import FluidsTestTab from "./Tables/FluidsTestTab.vue";
import TestLoaders from '../Loaders/TestLoaders.vue';
import axios from "axios";
import api from "../../../axiosInterceptor";
import { getDisplayName, getSortOrder } from '../../../utils/cache';
import { blobFromSampleReportResponse } from '../../../utils/sampleReportDownload';

export default {
  components: { WellInfoTab, FluidsTestTab, TestLoaders },
  name: "SampleValidationTabs",
  data: () => ({
    tab: null,
    receivedData: null,
    receivedDataProperties: null,
    assetName: "",
    fieldName: "",
    wellName: "",
    pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
    pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
    documentDownload: require("../../../assets/Images/csv.svg"),
    pdfLoader: false,
    snackbarMessage: null,
    sampleData: null,
  }),
  methods: {
    handleDataUpdate(data) {
      this.receivedData = data;
    },
    handleDataUpdateProperties(data) {
      this.receivedDataProperties = data;
    },
    goToPdf() {
      this.snackbarMessage = null;
      this.pdfLoader = true;
      const tenantId = getTenantPrefix() || "";
      const sampleId = this.$route.params.sampleId;
      axios
        .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/download`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "X-TenantID": tenantId,
          },
          responseType: 'blob',
        })
        .then(async (response) => {
          const result = await blobFromSampleReportResponse(response, 'pdf');
          this.pdfLoader = false;
          if (!result.ok) {
            this.snackbarMessage = result.message;
            return;
          }
          const url = URL.createObjectURL(result.blob);
          window.open(url, '_blank');
        })
        .catch(async (error) => {
          this.pdfLoader = false;
          const fallbackDownloadError = "Failed to download PDF report.";
          const data = error.response?.data;
          if (data instanceof Blob) {
            try {
              const text = await data.text();
              const j = JSON.parse(text);
              if (j && Number(j.statusCode) >= 500) {
                this.snackbarMessage = fallbackDownloadError;
                return;
              }
              if (j && j.message) {
                this.snackbarMessage = j.message;
                return;
              }
            } catch (_) {
              /* fall through */
            }
          }
          if (error.response) {
            if (Number(error.response.status) >= 500) {
              this.snackbarMessage = fallbackDownloadError;
              return;
            }
            this.snackbarMessage = "The PDF report is not available for synthetic data in this study/sample/test. Please explore tests/samples under Asset: Public Data to check the power of this feature.";
          }
        })
        .finally(() => {
          this.pdfLoader = false;
        });
    },
    handleKeyDown(event) {
      const key = event.key;
      if (key === 'ArrowDown') {
        this.$refs.scrollable.scrollTop += 50;
      } else if (key === 'ArrowLeft') {
        const currentIndex = this.tab ? ['one', 'two'].indexOf(this.tab) : 0;
        this.tab = currentIndex === 0 ? 'two' : 'one';
      } else if (key === 'ArrowRight') {
        const currentIndex = this.tab ? ['one', 'two'].indexOf(this.tab) : 0;
        this.tab = currentIndex === 1 ? 'one' : 'two';
      }
    },
    downloadWellInfoCSV() {
      if (this.$refs.wellInfoTab) {
        this.$refs.wellInfoTab.downloadCSV();
      }
    },
    downloadFluidsTestCSV() {
      if (this.$refs.fluidsTestTab) {
        this.$refs.fluidsTestTab.downloadCSV();
      }
    },
    async fetchSampleData() {
      try {
        const sampleId = this.$route.params.sampleId;
        if (sampleId) {
          const response = await api.get(`/public/api/samples/${sampleId}`);
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.sampleData = response.data.data;
          } else {
            console.error('Error fetching sample data:', response?.data?.message);
          }
        }
      } catch (error) {
        console.error('Error fetching sample data:', error);
      }
    }
  },
  mounted() {
    this.tab = 'one';
    this.assetName = this.$route.params.asset?.replace(/-/g, ' ') || '';
    this.fieldName = this.$route.params.field?.replace(/-/g, ' ') || '';
    this.wellName = this.$route.params.well || '';
    this.$refs.scrollable.focus();
    this.fetchSampleData();
  },
};
</script>
